export default class Alert {
  title: string;
  text: string | string[];
  okButton: string;
  okCallback: Function | null;
  cancelButton: string | null;
  cancelCallback: Function | null;

  constructor(
    title: string,
    text: string | string[],
    okButton: string = 'Ok',
    okCallback: Function | null = null,
    cancelButton: string | null = null,
    cancelCallback: Function | null = null
  ) {
    this.title = title;
    this.text = text;
    this.okButton = okButton;
    this.okCallback = okCallback;
    this.cancelButton = cancelButton;
    this.cancelCallback = cancelCallback;
  }
}



// WEBPACK FOOTER //
// ./src/data/Alert.ts